import mixin from "../../../mixins/mixin";
import formService from "../../../services/form";
import Datepicker from "vuejs-datepicker";
import { en, es, fr } from "vuejs-datepicker/dist/locale";
import TimePicker from "vue2-timepicker";

export default {
  data() {
    return {
      en: en,
      fr: fr,
      es: es,
      form: {},
      loading: true,
      rentalName: "",
      booking: {},
      inputs: {},
      auth: false,
      hourRange: [[0, 23]],
      minutes: ["00", "30"],
      hours: [],
      checkinDate: "",
      checkoutDate: "",
      extra_form_data: [],
      timeInHours: [],
      timeOutHours: [],
      stepCount: 0,
    };
  },
  components: {
    VLoading: require("components/loading/loading.vue"),
    Datepicker,
    VueTimepicker: TimePicker,
    VCheckinForm: require("./checkin-form/CheckinForm"),
  },
  mixins: [mixin],

  async mounted() {
    const vm = this;
    if (vm.$route.params.booking_permalink && vm.$route.params.form_type) {
      await formService.getBookingForm(
        vm,
        vm.$route.params.booking_permalink,
        vm.$route.params.form_type
      );
      await this.getBookingByPermalink();
      await vm.prefillForm();
      this.loading = false;

      this.checkUserTimeZone(vm, vm.booking.checking, vm.booking.checkout);
      for (let i = 0; i < 24; i++) {
        for (let j = 0; j < vm.minutes.length; j++) {
          i < 10
            ? vm.hours.push(`0${i}:${vm.minutes[j]}`)
            : vm.hours.push(`${i}:${vm.minutes[j]}`);
        }
      }

      vm.timeInHours = vm.getTimeInHourRange();
      vm.timeOutHours = vm.getTimeOutHourRange();
    }
  },

  watch: {
    form(val) {
      this.stepCount =
        val.steps && val.steps.length > 0 ? val.steps.length + 1 : 1;
    },
  },

  methods: {
    prefillForm() {
      const vm = this;
      vm.inputs = {};
      const fields = vm.form.fields;
      // check time in field for booking
      const timeIn = vm.booking.time_in;
      if (timeIn) {
        vm.hourRange = [[timeIn.split(":")[0], 23]];
      }

      for (const obj in fields) {
        // skip loop if the property is from prototype
        if (!fields.hasOwnProperty(obj)) continue;

        vm.inputs[fields[obj].model] = {
          value: "",
          reference: false,
        };
        if (fields[obj].reference && fields[obj].model !== "comments") {
          if (
            [fields[obj].model] === "time_in" ||
            [fields[obj].model] === "time_out" ||
            [fields[obj].model] === "checking" ||
            [fields[obj].model] === "checkout"
          ) {
            if (
              fields[obj].type.name === "input" &&
              fields[obj].element.name === "time"
            ) {
              const val = vm.booking[fields[obj].model];
              if (val != null && val !== "") {
                vm.inputs[fields[obj].model].value = val;
              } else {
                vm.inputs[fields[obj].model].value = "";
              }
            } else {
              vm.inputs[fields[obj].model].value =
                vm.booking[fields[obj].model];
            }
          } else {
            vm.inputs[fields[obj].model].value =
              vm.booking.guest[fields[obj].model];
          }
          vm.inputs[fields[obj].model].reference = true;
          vm.inputs[fields[obj].model].bed24_key = [fields[obj].bed24_model];
        } else if (vm.extra_form_data) {
          if (
            vm.extra_form_data[fields[obj].model] &&
            fields[obj].model !== "comments"
          ) {
            vm.inputs[fields[obj].model].value =
              vm.extra_form_data[fields[obj].model];
          } else {
            vm.inputs[fields[obj].model].value = "";
          }
          vm.inputs[fields[obj].model].reference = false;
        }
      }
      if (vm.inputs.email) {
        vm.inputs.email.value = "";
      }
    },

    getTimeInHourRange() {
      const vm = this;
      let timeIn = null;
      let timeInEnd = null;
      if (vm.booking.rental.checkin) {
        const res = vm.booking.rental.checkin.split(":");
        const timeInRes = vm.booking.rental.checkin_end.split(":");
        if (res[0] && res[1]) {
          timeIn = `${res[0]}:${res[1]}`;
          if (timeInRes[0] && timeInRes[1]) {
            timeInEnd = `${timeInRes[0]}:${timeInRes[1]}`;
          }
          const start = vm.hours.indexOf(timeIn);
          const end = vm.hours.indexOf(timeInEnd);
          if (start !== -1) {
            return end !== -1 && start < end
              ? vm.hours.slice(start, end + 1)
              : vm.hours.slice(start);
          }
          return vm.hours;
        }
        return vm.hours;
      }
      return vm.hours;
    },

    getTimeOutHourRange() {
      const vm = this;
      let timeOut;
      if (vm.booking.rental.checkin) {
        const res = vm.booking.rental.checkout.split(":");
        if (res[0] && res[1]) {
          timeOut = `${res[0]}:${res[1]}`;
          const end = vm.hours.indexOf(timeOut);
          if (end != -1) {
            return vm.hours.slice(0, end + 1);
          }
          return vm.hours;
        }
        return vm.hours;
      }
      return vm.hours;
    },

    async submit() {
      const vm = this;
      vm.loading = true;
      await formService.updateBooking(
        vm,
        vm.inputs,
        vm.$route.params.booking_permalink
      );
    },

    async getBookingByPermalink() {
      await formService.getBookingByPermalink(
        this,
        this.$route.params.booking_permalink
      );
    },
  },

  computed: {
    language() {
      let lang = "en";
      const availableLanguages = ["en", "es", "fr"];
      if (this.booking && this.booking.guest && this.booking.guest.country) {
        const guestCountry = this.booking.guest.country.toLowerCase();
        if (availableLanguages.includes(guestCountry)) {
          lang = guestCountry;
        }
      }

      return lang === "fr" ? fr : lang === "en" ? en : lang === "es" ? es : en;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/form/show/show.js